interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const sizeMap = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-4',
  lg: 'h-12 w-12 border-4',
} as const;

export function LoadingSpinner({ size = 'md', label = 'Loading', className = '' }: LoadingSpinnerProps) {
  return (
    <div className={`inline-flex items-center justify-center ${className}`} role="status">
      <div
        className={`${sizeMap[size]} animate-spin rounded-full border-brand-primary-200 border-t-brand-primary-600`}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
